import type { XYChartThresholdProps } from '../types/xy-chart.js';

/**
 * @public
 */
export const Threshold = (props: XYChartThresholdProps) => null;

Threshold['displayName'] = 'XYChart.Threshold';
